import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import EmptyTableIcon from './EmptyTableIcon';

interface Props {
  openModal: () => void;
  allParticipantIds: number[];
}

function ParticipantsEmpty({ openModal, allParticipantIds }: Props) {
  return fromEmpty(allParticipantIds)
    .map(() => (
      <>
        <div className="mt-4 text-slate-500">
          <T kind="No participants in this group match your criteria. Please revise your criteria to view participants in this group." />
        </div>
        <EmptyTableIcon className="mt-12 mb-4" />
      </>
    ))
    .getOrElse(() => (
      <>
        <div
          className={clsx(
            'rounded-md cursor-pointer bg-teal-600 text-white px-3 py-2 text-sm w-36',
            'text-center font-normal mt-8',
          )}
          onClick={openModal}
        >
          <span>+ </span>
          <T kind="Add Participant" />
        </div>
        <div className="mt-4 text-slate-500">
          <T kind="You haven't added any participants to this group. Add a participant to get started." />
        </div>
        <EmptyTableIcon className="mt-12 mb-4" />
      </>
    ));
}

export default observer(ParticipantsEmpty);
